(function () {
  var datepicker = window.datepicker;

  var monthData
  var $wrapper
  //渲染函数，由于没有使用第三方插件或库，所以使用的是模板拼接的方法
  datepicker.buildUi = function (year, month, activeData, cb) {
    monthData = datepicker.getMonthDate(year, month)
    let canBack = (new Date().getFullYear() < monthData.year) || (new Date().getFullYear() == monthData.year && (new Date().getMonth() + 1) < monthData.month)
    var html =
      '<div class="ui-datepicker-header">' +
        '<span class="datepicker-curr-month">' +
        monthData.monthEn +
        " " +
        monthData.year +
        "</span>" +
      '<div>' +
      (canBack ? 
      ('<a href="#" class="ui-datepicker-btn ui-datepicker-prev-btn">' +
        '<svg style="margin-right: 0;transform: rotate(180deg);" class="ui-datepicker-btn ui-datepicker-prev-btn" width="10px" height="17px" viewBox="0 0 10 17" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">' +
            '<g class="ui-datepicker-btn ui-datepicker-prev-btn" id="LEMMO1.1.1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" stroke-linecap="round">' +
                '<g class="ui-datepicker-btn ui-datepicker-prev-btn" id="切图" transform="translate(-359.000000, -294.000000)" stroke="#282828" stroke-width="2">' +
                    '<g class="ui-datepicker-btn ui-datepicker-prev-btn" id="编组-3备份" transform="translate(359.777778, 295.000000)">' +
                        '<g class="ui-datepicker-btn ui-datepicker-prev-btn" id="编组-12" transform="translate(0.000000, 0.000000)">' +
                            '<path class="ui-datepicker-btn ui-datepicker-prev-btn" d="M0.324074074,0.324074074 L7.4537037,7.4537037 M7.4537037,7.5462963 L0.324074074,14.6759259" id="形状结合"></path>' +
                        '</g>' +
                    '</g>' +
                '</g>' +
            '</g>' +
        '</svg>' +
      '</a>') : 
      ('<a href="#" style="margin-right: 60px;cursor: no-drop;">' +
        '<svg width="10px" height="17px" viewBox="0 0 10 17" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">' +
        '<g id="LEMMO1.1.1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" stroke-linecap="round">' +
            '<g id="切图" transform="translate(-99.000000, -294.000000)" stroke="#D3D3D3" stroke-width="2">' +
                '<g id="编组-12" transform="translate(103.888889, 302.500000) scale(-1, 1) translate(-103.888889, -302.500000) translate(100.000000, 295.000000)">' +
                    '<path d="M0.324074074,0.324074074 L7.4537037,7.4537037 M7.4537037,7.5462963 L0.324074074,14.6759259" id="形状结合"></path>' +
                '</g>' +
            '</g>' +
        '</g>' +
      '</svg>' +
      '</a>'))
      + '<a href="#" class="ui-datepicker-btn ui-datepicker-next-btn">'+
          '<svg class="ui-datepicker-btn ui-datepicker-next-btn" width="10px" height="17px" viewBox="0 0 10 17" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">' +
              '<g class="ui-datepicker-btn ui-datepicker-next-btn" id="LEMMO1.1.1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" stroke-linecap="round">' +
                  '<g class="ui-datepicker-btn ui-datepicker-next-btn" id="切图" transform="translate(-359.000000, -294.000000)" stroke="#282828" stroke-width="2">' +
                      '<g class="ui-datepicker-btn ui-datepicker-next-btn" id="编组-3备份" transform="translate(359.777778, 295.000000)">' +
                          '<g class="ui-datepicker-btn ui-datepicker-next-btn" id="编组-12" transform="translate(0.000000, 0.000000)">' +
                              '<path class="ui-datepicker-btn ui-datepicker-next-btn" d="M0.324074074,0.324074074 L7.4537037,7.4537037 M7.4537037,7.5462963 L0.324074074,14.6759259" id="形状结合"></path>' +
                          '</g>' +
                      '</g>' +
                  '</g>' +
              '</g>' +
          '</svg>' +
      '</a></div>' +
      "</div>" +
      '<div class="ui-datepicker-body">' +
        '<div class="ui-datepicker-body-header">' +
          '<div class="ui-datepicker-body-header-item">MON</div>' +
          '<div class="ui-datepicker-body-header-item">TUE</div>' +
          '<div class="ui-datepicker-body-header-item">WED</div>' +
          '<div class="ui-datepicker-body-header-item">THU</div>' +
          '<div class="ui-datepicker-body-header-item">FRI</div>' +
          '<div class="ui-datepicker-body-header-item">SAT</div>' +
          '<div class="ui-datepicker-body-header-item">SUN</div>' +
        '</div>' +
        '<div class="ui-datepicker-body-content">'

    for (var i = 0; i < monthData.days.length; i++) {
      var date = monthData.days[i]
      if (date.date == date.showDate) {
        activeData.forEach(item => {
          if (item.status == 1 && (new Date(item.date).getTime() == new Date(monthData.year + '-' + (monthData.month > 9 ? monthData.month : ('0'+ monthData.month)) + '-' + (date.showDate > 9 ? date.showDate : ('0'+ date.showDate))).getTime())) {
            date.active = true
          }
        })
      }
      
      if (i % 7 === 0) {
        html += '<div class="ui-datepicker-body-content-row">'
      }
      html += '<div class="ui-datepicker-body-content-row-item ' + ((date.date == date.showDate && date.active) ? "ui-datepicker-body-content-row-item-in" : "ui-datepicker-body-content-row-item-out")  +'" data-date="' + date.date + '">' + date.showDate + "</div>";
      if (i % 7 == 6) {
        html += "</div>"
      }
    }

    // html += "</tbody>" + "</table>" + "</div>"
    html += "</div>" + "</div>"
    
    return html
  };
  //日历渲染函数
  datepicker.render = function (parentDom, direction, activeData, cb) {
    var year, month
    if (monthData) {
      year = monthData.year
      month = monthData.month
    }
    if (direction === "prev") month--
    if (direction === "next") month++ 
    var html = datepicker.buildUi(year, month, activeData, cb)

    $wrapper = document.querySelector(".ui-datepicker-wrapper")

    if (!$wrapper) {
      $wrapper = document.createElement("div")
      $wrapper.className = "ui-datepicker-wrapper"
    }
    $wrapper.innerHTML = ''
    $wrapper.innerHTML = html

    parentDom.appendChild($wrapper)
  };
  
  //初始换函数
  datepicker.init = function (input, activeData, cb) {
    var $input=document.querySelector(input)
    datepicker.render($input,'', activeData, cb)
    $wrapper.classList.add("ui-datepicker-wrapper-show")
    //给按钮添加点击事件
     $($wrapper).unbind()
     $($wrapper).bind('click',function (e) {
        clickEvent(e, $input, activeData, cb)
       console.log(e)
       e.stopPropagation()
      }
    )
   
    var startx,movex,endx,nx;
   //开始触摸函数，event为触摸对象
   function touchs(event){
       
       if(event.type=="touchstart"){//通过if语句判断event.type执行了哪个触摸事件
           var touch = event.touches[0];//获取开始的位置数组的第一个触摸位置
           startx = Math.floor(touch.pageX);//获取第一个坐标的X轴
       }else if(event.type=="touchmove"){//触摸中的坐标获取
           var touch = event.touches[0];
           movex = Math.floor(touch.pageX);
       }else if(event.type == "touchend" || event.type == "touchcancel"){//当手指离开屏幕或系统取消触摸事件的时候
           endx = Math.floor(event.changedTouches[0].pageX);//获取最后的坐标位置
           nx = endx-startx;//获取开始位置和离开位置的距离
           //判断滑动方向
           if(nx > 50){
             datepicker.render($input,"prev", activeData, cb)
            return false;
           }else if(nx < -50){
             datepicker.render($input,"next", activeData, cb)
            return false;
           } else {
             console.log('')
           }
       }
   }
   //添加触摸事件的监听，并直行自定义触摸函数
   // $wrapper.addEventListener('touchstart',touchs,false);
   // $wrapper.addEventListener('touchmove',touchs,false);
   // $wrapper.addEventListener('touchend',touchs,false);
  }
  function clickEvent(e, $input, activeData, cb) {
    debounce(changeMonth(e, $input, activeData, cb),100)
    selectDay(e, $input, activeData, cb)
  }
  function debounce(func, wait, immediate) {
      var timeout;
      return function() {
          clearTimeout(timeout);
          timeout = setTimeout(func, wait);
      };
  }
  // 上下个月切换事件
  function changeMonth (e, $input, activeData, cb) {
      var $target = e.target
      if (!$target.classList.contains("ui-datepicker-btn")) {
        return false
      }
      //上一月,下一月
      if ($target.classList.contains("ui-datepicker-prev-btn")) {
        datepicker.render($input,"prev", activeData, cb)
      } else if ($target.classList.contains("ui-datepicker-next-btn")) {
        datepicker.render($input,"next", activeData, cb)
      }
    }
  // 日期选中事件
    function selectDay (e, $input, activeData, cb) {
        var $target = e.target
        if ($target.classList.contains("ui-datepicker-body-content-row-item-in")) {
          let date =monthData.year + '-' + monthData.month + '-' +$target.dataset.date
          cb(date)
        }
        
        
      }
  //格式化数据
  function format(date) {
    var ret = ""

    var padding = function (num) {
      if (num <= 9) {
        return "0" + num
      }
      return num
    };

    ret += date.getFullYear() + "-"
    ret += padding(date.getMonth() + 1) + "-"
    ret += padding(date.getDate())

    return ret
  }
})()
